import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import s from './MediumSophisticatedTooltipHeading.scss';
const MediumSophisticatedTooltipHeading = (_param)=>/*#__PURE__*/ {
    var { children , className  } = _param, rest = _object_without_properties(_param, [
        "children",
        "className"
    ]);
    return React.createElement("span", _extends({
        className: c(s['root'], className)
    }, rest), children);
};
MediumSophisticatedTooltipHeading.displayName = 'MediumSophisticatedTooltipHeading';
export default MediumSophisticatedTooltipHeading;
